<template>
  <v-app id="tk">
    <div v-if="this.$store.state.authState === 'unauthenticated'" id="login">
      <amplify-authenticator>
        <amplify-sign-in :sign-in-config="signInConfig" />
      </amplify-authenticator>
    </div>
    <div v-if="this.$store.state.authState === 'authenticated'" id="content">
      <v-navigation-drawer v-model="drawer" app clipped>
        <v-list dense nav>
          <v-list-item link to="/">
            <v-list-item-content>
              <v-list-item-title>Summary</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/monitored">
            <v-list-item-content>
              <v-list-item-title>Monitored Races</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/upcoming">
            <v-list-item-content>
              <v-list-item-title>Upcoming Races</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/bets">
            <v-list-item-content>
              <v-list-item-title>Placed Bets</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/statistics">
            <v-list-item-content>
              <v-list-item-title>Statistics</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/analysis">
            <v-list-item-content>
              <v-list-item-title>Analysis</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/dashboards">
            <v-list-item-content>
              <v-list-item-title>Dashboards</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/settings">
            <v-list-item-content>
              <v-list-item-title>Settings</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/schedule-basic">
            <v-list-item-content>
              <v-list-item-title>Schedule</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/logs">
            <v-list-item-content>
              <v-list-item-title>Logs</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/debug">
            <v-list-item-content>
              <v-list-item-title>Debug</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
          <v-list-item link @click="() => this.$store.dispatch('logout')">
            <v-list-item-content>
              <v-list-item-title>Log Out</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <v-app-bar app dense dark :color="appColor" clipped-left>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
        <v-img
          src="slippy.png"
          height="32"
          max-width="32"
          class="header-icon ml-2 mr-5"
        />
        <v-toolbar-title> Slippy </v-toolbar-title>
        <v-spacer />
        <v-icon v-if="$vuetify.breakpoint.xs" @click="refreshPage">
          mdi-refresh
        </v-icon>
      </v-app-bar>

      <v-main class="tk-content mx-lg-12 mx-xl-12">
        <v-container fluid>
          <div class="headline ml-2 mb-2">{{ this.$route.name }}</div>
          <router-view ref="view" />
        </v-container>
      </v-main>
    </div>
    <div v-if="this.$store.state.authState === 'loading'" id="loading">
      <v-progress-circular indeterminate size="64" />
    </div>
    <notification />
  </v-app>
</template>

<script>
import { components, AmplifyEventBus } from "aws-amplify-vue";
import Notification from "./components/Notification";

import pollState from "./lib/polling";

export default {
  components: {
    ...components,
    Notification
  },
  data() {
    return {
      drawer: false,
      signInConfig: {
        isSignUpDisplayed: false
      }
    };
  },
  async created() {
    this.$store.dispatch("checkLogin");

    AmplifyEventBus.$on("authState", info => {
      this.$store.dispatch("checkLogin");

      if (info === "signedIn") {
        this.$store.commit("authState", "authenticated");
      } else {
        this.$store.commit("authState", "unauthenticated");
      }
    });

    pollState();
  },
  methods: {
    refreshPage() {
      if (this.$refs.view.refresh) {
        this.$refs.view.refresh();
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user.email;
    },
    appColor() {
      return this.$store.state.user.isDemo ? "purple" : "primary";
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#loading {
  margin: auto;
}

#login {
  margin: auto;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
